export default defineNuxtPlugin(() => {
  const router = useRouter();
  const config = useRuntimeConfig();
  const gtagId = config.public.gtagId || process.env.NUXT_PUBLIC_GTAG_ID;

  // Skip if gtagId is not provided
  if (!gtagId) {
    return;
  }

  // Track page views on route changes
  router.afterEach((to) => {
    // Wait for next tick to ensure gtag is available
    nextTick(() => {
      if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
        window.gtag('config', gtagId, {
          page_path: to.fullPath,
        });
      }
    });
  });
});
